import API from '.';
export default {
    getTaskList: (params) => {
        return API.get('/tasks/list', {
            params
        });
    },
    getTaskListByCategory: (params) => {
        return API.get(`/tasks/category/${params.categoryId}`, params);
    },
    getStationList: (post) => {
        return API.get('/crm/stations/list')
    },

    create: (params) => {
        return API.post(`/tasks/add`, params)
    },
    comment: (params) => {
        return API.post(`/tasks/comments/add`, params)
    },
    // edit: (params) => {
    //     return API.put(`/add`)
    // },
    complite: (id) => {
        return API.put(`/tasks/${id}/completed`)
    },
    activate: (id) => {
        return API.put(`/tasks/${id}/activate`)
    },
    compliteWithUser: (id) => {
        return API.put(`/tasks/${id}/completed_with_user`)
    },
    activateWithUser: (id) => {
        return API.put(`/tasks/${id}/activate_with_user`)
    },
    setFavorute: (params) => {
        return API.put(`/tasks/set_favorit`, params)
    },
}